import Checkmark from "components/Creation/components/checkmark";
import React from "react";
const Option = ({ onClick, isSelected, option }) => {
  return (
    <div className="w-full ">
      <div className="flex items-center gap-2 cursor-pointer" onClick={onClick}>
        <div className="text-[2em]">
          <Checkmark isUnselected={!isSelected} />
        </div>
        <div className="font-bold">{option.answer}</div>
      </div>
    </div>
  );
};

export default Option;
